import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IRadioBtnItemModel} from '../iradio-btn-item';

@Component({
  selector: 'li3-radio-btns',
  templateUrl: './radio-btns.component.html',
  styleUrls: ['./radio-btns.component.scss']
})

export class RadioBtnsComponent implements OnInit {
  @Input() data: IRadioBtnItemModel[];
  @Input() value: string;
  @Output() changed = new EventEmitter <string>();

  constructor() {
  }

  ngOnInit() {
  }

  isItemChecked(itemValue: string) {
    return itemValue === this.value ? '1' : '0';
  }

  onChange(value) {
    this.value = value;
    this.changed.emit(value);
  }
}
